export default __webpack_public_path__ + "static/media/ConferenceOnlineIcon.a3a1615e.svg";